export default "__VITE_ASSET__Do8tA8lX__"